<template>
  <transition name="contact-dialog-fade">
    <div v-if="visible" class="contact-dialog" @click.self="handleClose">
      <div class="panel">
        <button type="button" class="close" aria-label="关闭联系我们弹窗" @click="handleClose">
          <img src="../../../assets/home-confirm/dialogs/contact-close.svg" alt="" class="close-icon" />
        </button>

        <p class="title">联系我们</p>

        <div class="content" v-html="contentHtmlText"></div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ContactDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    contentHtml: {
      type: String,
      default: "",
    },
  },
  computed: {
    contentHtmlText() {
      return String(this.contentHtml || "").trim() || "<p>暂无联系方式</p>";
    },
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.contact-dialog {
  position: fixed;
  inset: 0;
  z-index: 1997;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
  background: rgba(0, 0, 0, 0.5);
}

.panel {
  box-sizing: border-box;
  width: 1217px;
  height: 322px;
  padding: 15px 17px 5px 91px;
  background: #ffffff;
}

.close {
  display: block;
  margin-left: auto;
  border: 0;
  padding: 0;
  background: transparent;
  cursor: pointer;
}

.close-icon {
  width: 14px;
  height: 14px;
}

.title {
  margin: 11px 0 0;
  color: #000000;
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
}

.contact-dialog-fade-enter-active,
.contact-dialog-fade-leave-active {
  transition: opacity 0.2s ease;
}

.contact-dialog-fade-enter-active .panel,
.contact-dialog-fade-leave-active .panel {
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.contact-dialog-fade-enter,
.contact-dialog-fade-leave-to {
  opacity: 0;
}

.contact-dialog-fade-enter .panel,
.contact-dialog-fade-leave-to .panel {
  opacity: 0;
  transform: translateY(12px) scale(0.98);
}
</style>
<style scoped src="./ContactDialog.mobile.css"></style>
